/**
 * Searches for objects in the given array that contain the specified search term.
 * @param {Array} array - The array of objects to search.
 * @param {string} searchTerm - The search term to look for.
 * @returns {Array} - An array containing objects that match the search term.
 */
export function handleGlobalRowSearch(array, searchTerm) {
  const results = []
  if (typeof searchTerm !== 'string') return []

  function searchObject(obj, term, parentObj = null) {
    let isFound = false
    Object.entries(obj).forEach(([key, value]) => {
      const formattedValue =
        typeof value === 'string' || typeof value === 'number' ? String(value) : value
      if (!isFound) {
        if (Array.isArray(formattedValue) && isNaN(Number(searchTerm))) {
          formattedValue.forEach((el) => searchObject(el, term, obj))
        } else if (
          typeof formattedValue === 'object' &&
          formattedValue &&
          isNaN(Number(searchTerm))
        ) {
          searchObject(formattedValue, term)
        } else if (
          typeof formattedValue === 'string' &&
          (formattedValue.toLowerCase().includes(term) || formattedValue === term)
        ) {
          results.push(parentObj ?? obj)
          isFound = true
        }
      }
    })
  }
  array.forEach((obj) => searchObject(obj, searchTerm.toLowerCase()))
  return results
}

/**
 * Number format.
 * @param {Number} num - number.
 * @returns {String}
 */
export const numberAbrevations = (num) => {
  if (num >= 1_000_000_000_000) {
    return 'T'
  } else if (num >= 1_000_000_000) {
    return 'B'
  } else if (num >= 1_000_000) {
    return 'M'
  } else if (num >= 1_000) {
    return 'K'
  }
}
/**
 * Number format.
 * @param {Number} num - number.
 * @returns {String}
 */
export const formatNumber = (num, fixDec = 2, maxValueFixDec = 0) => {
  if (typeof num !== 'number') return num
  if (num >= 1_000_000_000_000) {
    return (num / 1_000_000_000_000).toFixed(maxValueFixDec) + 'T'
  } else if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(maxValueFixDec) + 'B'
  } else if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(maxValueFixDec) + 'M'
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(maxValueFixDec) + 'K'
  } else {
    // if(num < 1) return num.toFixed(4)
    return num.toFixed(fixDec)
  }
}

/**
 * Currency format.
 * @param {Number} value - number.
 * @returns {String}
 */
export const formatCurrency = (
  value = 0,
  sign = '$',
  currencyExchange = 1,
  fixDec,
  maxValueFixDec = 0,
) => {
  if (typeof value !== 'number') return value
  const absoluteValue = Math.abs(value) * currencyExchange
  const formattedValue = `${sign} ${formatNumber(absoluteValue ?? 0, fixDec, maxValueFixDec)}`
  return formattedValue
}
export const formatPercentage = (value = 0, sign = '%', fixDec = 2) => {
  if (typeof value !== 'number') return value
  const absoluteValue = Math.abs(value)
  const formattedValue = `${(absoluteValue ?? 0).toFixed(fixDec)}${sign}`
  return formattedValue
}
export const percentageConverter = (minValue = 0, maxValue = 0, fixDec = 0) => {
  if (typeof minValue !== 'number' || typeof maxValue !== 'number') return 0
  const convertedValue = parseFloat(((minValue / maxValue) * 100).toFixed(fixDec))
  return convertedValue
}
